const escapeCsvCell = (value) => {
    const str = String(value ?? "");
    return /[",\n]/.test(str) ? `"${str.replace(/"/g, "\"\"")}"` : str;
};

export const triggerDownload = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const rowsToCsvBlob = (rows, columns) => {
    const header = columns.map((col) => escapeCsvCell(col.label)).join(",");
    const lines = rows.map((row) => columns.map((col) => escapeCsvCell(col.value(row))).join(","));
    return new Blob([[header, ...lines].join("\n")], { type: "text/csv;charset=utf-8;" });
};
